/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {MainUiProps} from './UIDefault';
import {$ControlsPanelPortrait} from './ControlsPanelPortrait';
import {$ControlsPanelLandscape} from './ControlsPanelLandscape';

export const $BottomPanel: FC<MainUiProps> = (props) => {
    return <$Container name='bottom_panel'>
        <$ControlsPanelPortrait {...props}/>
        <$ControlsPanelLandscape {...props}/>
    </$Container>;
};